import { css } from "@emotion/react"
import Header from "./header"
import Footer from "./footer"

import "./layout.css"
import { theme } from "../constants/theme"

const Layout = ({ title, children, fluid = false, nav, base }) => {
  return (
    <div css={css`background: ${theme.colors.backgroound};`}>
      <Header title={title} nav={nav} base={base} />
      <div
        css={css`
          box-sizing: border-box;
          margin: 0 auto 0;
          max-width: ${fluid ? theme.size.laptopL : "750px"};
          padding: 100px 20px 1.45rem;
          @media ${theme.devices.max.laptopL} {
            max-width: ${theme.size.tablet};
          }
        `}
      >
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
